import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLifeRing,
  faCircleQuestion,
  faComments,
  faShieldHalved,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";

const LINKS = [
  { key: "faq", icon: faCircleQuestion, label: "FAQ", desc: "Frequently asked questions", href: "#" },
  { key: "contact", icon: faComments, label: "Contact Support", desc: "Get help from our team", href: "#" },
  { key: "privacy", icon: faShieldHalved, label: "Privacy Policy", desc: "How we handle your data", href: "#" },
  { key: "terms", icon: faFileContract, label: "Terms of Service", desc: "Usage terms and conditions", href: "#" },
];

function SupportSection({ darkMode, t }) {
  return (
    <div className="profile-section">
      <div className="profile-section-header">
        <div className="profile-section-icon">
          <FontAwesomeIcon icon={faLifeRing} />
        </div>
        <div>
          <h2 className="profile-section-title">{t("Help & Support")}</h2>
          <p className="profile-section-desc">{t("Resources and assistance")}</p>
        </div>
      </div>

      <div className="profile-support-grid">
        {LINKS.map((link) => (
          <a key={link.key} href={link.href} className="profile-support-card">
            <div className="icon">
              <FontAwesomeIcon icon={link.icon} />
            </div>
            <div className="profile-support-text">
              <span>{t(link.label)}</span>
              <small>{t(link.desc)}</small>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default SupportSection;
